import { Grey } from '@/styles/Colors';
import React, { useId } from 'react';

import StyledCheckbox from './StyledCheckBox';

export interface CheckboxProps {
  className?: string;
  color?: string;
  onChange?: (checked: boolean) => void;
  checked?: boolean;
  disabled?: boolean;
  caption?: string;
  /**
   * The accessible name, for the majority of call sites that render no visible
   * `caption` (ISSUE-071). Wins over `caption` when both are given, so a short
   * visible label can pair with a fuller spoken one.
   */
  'aria-label'?: string;
}
const Checkbox: React.FC<CheckboxProps> = ({
  className,
  caption,
  color,
  checked,
  disabled,
  onChange,
  'aria-label': ariaLabel,
}) => {
  const checkboxId = useId();
  return (
    <StyledCheckbox className={className} color={disabled ? Grey[200] : color}>
      <input
        type="checkbox"
        id={checkboxId}
        checked={checked}
        disabled={disabled}
        // Every Checkbox in the app used to be anonymous (ISSUE-071): the
        // <label> held only hidden STATE text and `caption` rendered outside
        // it, so neither could be the name. `caption` is the fallback because
        // where it exists it is exactly the visible label.
        aria-label={ariaLabel ?? caption}
        onChange={(e) => onChange?.(e.target.checked)}
      />
      {/* The styled box, and the visible hit target. Deliberately empty: it
          used to carry `checked ? 'checked' : 'unchecked'`, which duplicated
          what the checkbox role already conveys, flipped the name with the
          state, and was `visibility: hidden` so it reached nothing anyway. */}
      <label htmlFor={checkboxId} />
      {caption && <span className="checkbox-caption">{caption}</span>}
    </StyledCheckbox>
  );
};
export default Checkbox;
